import "./session-format-toggle.css";
import { jsxs as d, jsx as t } from "react/jsx-runtime";
import { useCallback as p } from "react";
import { c as f } from "./index-B28ZDQcm.mjs";
import { RadioGroup as u, Label as F } from "react-aria-components";
import { RulaRadioBtn as T } from "@pathccm/rula-ui/form";
import { a as i } from "./session-format-BqFcXWgh.mjs";
const j = "_sessionFormatToggleGroup_5fz4j_26", S = "_sessionFormatToggle_5fz4j_26", r = {
  sessionFormatToggleGroup: j,
  sessionFormatToggle: S
}, _ = (o) => Object.keys(i).includes(
  o
);
function N({
  onChange: o,
  defaultSessionFormat: n,
  sessionFormat: e,
  className: l,
  ...a
}) {
  const m = e !== void 0 ? void 0 : n ?? "telemedicine", c = p(
    (s) => {
      o && _(s) && o(s);
    },
    [o]
  );
  return /* @__PURE__ */ d(
    u,
    {
      ...a,
      className: f(r.sessionFormatToggleGroup, l),
      defaultValue: m,
      onChange: c,
      value: e,
      children: [
        /* @__PURE__ */ t(F, { hidden: !0, children: "Select session format" }),
        Object.entries(i).map(([s, g]) => /* @__PURE__ */ t(
          T,
          {
            style: "Selectbox",
            value: s,
            className: r.sessionFormatToggle,
            children: g
          },
          s
        ))
      ]
    }
  );
}
export {
  N as S
};
